export default __webpack_public_path__ + "static/media/duplicate.157eaff8.svg";